import { useState } from "react";
import { Menu, X, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { whatsappLink } from "../data/content";

const LINKS = [
  { href: "#artisti", label: "Artisti & Spettacoli" },
  { href: "#produzioni", label: "Produzioni" },
  { href: "#agenzia", label: "L'Agenzia" },
  { href: "#contatti", label: "Contatti" },
];

export const Navbar = ({ onNavigate }) => {
  const [open, setOpen] = useState(false);

  const go = (href) => {
    setOpen(false);
    onNavigate(href);
  };

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#08070B]/80 border-b border-white/10"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo-link"
          onClick={() => go("#home")}
          className="shrink-0"
          aria-label="Musica & Moda 5.0 — home"
        >
          <Logo compact />
        </button>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="text-sm text-[#A19CAE] hover:text-[#E6C594] transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-whatsapp-button"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 rounded-full bg-[#E6C594] text-[#08070B] text-sm font-semibold px-5 py-2.5 hover:bg-[#FFF0D0] transition-colors duration-300"
          >
            <MessageCircle size={16} />
            WhatsApp Diretto
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden text-[#F4F1EE] p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-white/10 bg-[#08070B]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              onClick={() => go(l.href)}
              className="text-left text-base text-[#F4F1EE]"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-mobile-whatsapp-button"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 rounded-full bg-[#E6C594] text-[#08070B] text-sm font-semibold px-5 py-3"
          >
            <MessageCircle size={16} />
            WhatsApp Diretto
          </a>
        </div>
      )}
    </header>
  );
};
